import React from 'react';
import { PrismicHTML } from 'components/Prismic';
import { Container } from '../../UI/Container/Container';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import './TextBlock.scss';
import { PrismicRichTextFieldType } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';

type TextBlockProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.textBlock;
        primary: {
            text_block_content: PrismicRichTextFieldType;
        };
    };
};

const TextBlock = ({ slice }: TextBlockProps) => {
    return (
        <Container size="md">
            <Grid className="Text-block">
                <GridRow horizontalAlign={'h-start'} verticalAlign={'v-center'} className="Bloc-row">
                    <GridCol colSize={`10`} offsetSize={`0`} mobileColSize={'12'}>
                        <PrismicHTML content={slice.primary.text_block_content} />
                    </GridCol>
                </GridRow>
            </Grid>
        </Container>
    );
};

export { TextBlock, TextBlockProps };
